import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import { DriverSourceEnum } from "services/api/fleet/vehicles/drivers/types";

/** Vozač je korisnik aplikacije ili osoba iz imenika. */
export const DRIVER_SOURCE_FILTER_OPTIONS: DropdownOption[] = [
  { value: DriverSourceEnum.USER, text: "Korisnik aplikacije" },
  { value: DriverSourceEnum.CONTACT, text: "Kontakt" },
];

/** Prečaci za rokove isprava; `days: null` znači "već istekle". */
export const DRIVER_EXPIRY_FILTER_OPTIONS: (DropdownOption & {
  days: number | null;
})[] = [
  { value: "expired", text: "Istekle isprave", days: null },
  { value: "30", text: "Isteku u 30 dana", days: 30 },
  { value: "60", text: "Isteku u 60 dana", days: 60 },
  { value: "90", text: "Isteku u 90 dana", days: 90 },
];
